import env from '../../env';
export const INVOICES_DOMAIN = 'app/modules/Contents/INVOICES_DOMAIN';
export const REQUEST_INVOICES = 'app/modules/Contents/REQUEST_INVOICES';
export const REQUEST_INVOICES_SEARCH = 'app/modules/Contents/REQUEST_INVOICES_SEARCH';
export const REQUEST_INVOICE = 'app/modules/Contents/REQUEST_INVOICE';
export const REQUEST_INVOICE_BARE = 'app/modules/Contents/REQUEST_INVOICE_BARE';
export const REQUEST_COMPANY_INVOICES = 'app/modules/Contents/REQUEST_COMPANY_INVOICES';
export const REQUEST_VEHICLE_INVOICES = 'app/modules/Contents/REQUEST_VEHICLE_INVOICES';
export const REQUEST_DATA_RESULT = 'app/modules/Contents/REQUEST_INVOICE';
export const REQUEST_INVOICE_FILTER = 'app/modules/Contents/REQUEST_INVOICE_FILTER';
export const REQUEST_INVOICE_STATUS_LIST = 'app/modules/Contents/REQUEST_INVOICE_STATUS_LIST';
export const REQUEST_RELATION_SOURCE_LIST = 'app/modules/Contents/REQUEST_RELATION_SOURCE_LIST';
export const FILTER_DEFAULT_LIMIT = 50;
export const REQUEST_CREATE_INVOICE = 'app/modules/Contents/REQUEST_CREATE_INVOICE';
export const REQUEST_UPDATE_INVOICE = 'app/modules/Contents/REQUEST_UPDATE_INVOICE';
export const REQUEST_UPDATE_INVOICE_V2 = 'app/modules/Contents/REQUEST_UPDATE_INVOICE_V2';
export const INITIATE_INVOICE_EDIT = 'app/modules/Contents/INITIATE_INVOICE_EDIT';
export const SET_EDIT_INVOICE_VALUE = 'app/modules/Contents/SET_EDIT_INVOICE_VALUE';
export const REQUEST_ADD_INVOICE_RELATION_SOURCE = 'app/modules/Contents/REQUEST_ADD_INVOICE_RELATION_SOURCE';
export const REQUEST_REMOVE_INVOICE_RELATION_SOURCE = 'app/modules/Contents/REQUEST_REMOVE_INVOICE_RELATION_SOURCE';
export const REQUEST_ADD_INVOICE_SUBJECT = 'app/modules/Contents/REQUEST_ADD_INVOICE_SUBJECT';
export const REQUEST_UPDATE_INVOICE_SUBJECT = 'app/modules/Contents/REQUEST_UPDATE_INVOICE_SUBJECT';
export const REQUEST_REMOVE_INVOICE_SUBJECT = 'app/modules/Contents/REQUEST_REMOVE_INVOICE_SUBJECT';
export const REQUEST_UPDATE_INVOICE_STATUS = 'app/modules/Contents/REQUEST_UPDATE_INVOICE_STATUS';
export const REQUEST_INVOICE_SET_PARENT_INVOICE = 'app/modules/Contents/REQUEST_INVOICE_SET_PARENT_INVOICE';
export const REQUEST_INVOICE_SET_SUB_INVOICE = 'app/modules/Contents/REQUEST_INVOICE_SET_SUB_INVOICE';
export const REQUEST_ADD_INVOICE_VAT = 'app/modules/Contents/REQUEST_ADD_INVOICE_VAT';
export const REQUEST_REMOVE_INVOICE_VAT = 'app/modules/Contents/REQUEST_REMOVE_INVOICE_VAT';
export const REQUEST_EXACT_EXPORT_INVOICE = 'app/modules/Contents/REQUEST_EXACT_EXPORT_INVOICE';
export const REQUEST_EXACT_AUTH_STATUS = 'app/modules/Contents/REQUEST_EXACT_AUTH_STATUS';
export const REQUEST_EXACT_AUTH_LINK = 'app/modules/Contents/REQUEST_EXACT_AUTH_LINK';
export const REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS = 'app/modules/Contents/REQUEST_EXACT_WEBHOOK_SUBSCRIPTIONS';
export const REQUEST_ADD_EXACT_WEBHOOK_SUBSCRIPTION = 'app/modules/Contents/REQUEST_ADD_EXACT_WEBHOOK_SUBSCRIPTION';
export const REQUEST_DELETE_EXACT_WEBHOOK_SUBSCRIPTION = 'app/modules/Contents/REQUEST_DELETE_EXACT_WEBHOOK_SUBSCRIPTION';
export const REQUEST_VAT_CODES = 'app/modules/Contents/REQUEST_VAT_CODES';
export const REQUEST_COMPANY_TRANSPORT_LOCATIONS = 'app/modules/Contents/REQUEST_COMPANY_TRANSPORT_LOCATIONS';
export const REQUEST_AMOUNTS_CALCULATIONS = 'app/modules/Contents/REQUEST_AMOUNTS_CALCULATIONS';
export const REQUEST_INVOICE_EMAIL = 'app/modules/Contents/REQUEST_INVOICE_EMAIL';
export const REQUEST_INVOICE_DOWNLOAD = 'app/modules/Contents/REQUEST_INVOICE_DOWNLOAD';
export const REQUEST_INVOICE_DECLINE = 'app/modules/Contents/REQUEST_INVOICE_DECLINE';
export const REQUEST_INVOICE_DELETE = 'app/modules/Contents/REQUEST_INVOICE_DELETE';
export const REQUEST_SYNC_BPM = 'app/modules/Contents/REQUEST_SYNC_BPM';
export const REQUEST_CREATE_CREDIT_INVOICE = 'app/modules/Contents/REQUEST_CREATE_CREDIT_INVOICE';
export const REQUEST_UPDATE_INVOICE_DATE = 'app/modules/Contents/REQUEST_UPDATE_INVOICE_DATE';
export const REQUEST_UPDATE_INVOICE_OUTGOING_BPM = 'app/modules/Contents/REQUEST_UPDATE_INVOICE_OUTGOING_BPM';
export const REQUEST_UPDATE_INVOICE_GROSS_BPM = 'app/modules/Contents/REQUEST_UPDATE_INVOICE_GROSS_BPM';
export const GET_CURRENT_REST_BPM = 'app/modules/Contents/GET_CURRENT_REST_BPM';
export const FINALIZE_EXPORT_MAIL_INVOICE = 'app/modules/Contents/FINALIZE_EXPORT_MAIL_INVOICE';
export const REQUEST_PRODUCT_INVOICES = 'app/modules/Contents/REQUEST_PRODUCT_INVOICES';
export const INITIATE_PRODUCT_INVOICE_CREATE = 'app/modules/Contents/INITIATE_PRODUCT_INVOICE_CREATE';
export const REQUEST_LEDGERS = 'app/modules/Contents/REQUEST_LEDGERS';
export const REQUEST_LAST_PRODUCT_INVOICE_ID = 'app/modules/Contents/REQUEST_LAST_PRODUCT_INVOICE_ID';
export const REQUEST_INVOICE_TRADE_IN_VEHICLES = 'app/modules/Contents/REQUEST_INVOICE_TRADE_IN_VEHICLES';

export const INVOICE_STATUSES = {
  OPEN: 'OPEN',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  CANCELLED_CONCEPT: 'CANCELLED_CONCEPT',
};

export const INVOICE_DIRECTIONS = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
};

export const INVOICE_CONTENT_TYPES = {
  INCOMING: 'CAR',
  OUTGOING: 'COST',
  BPM: 'BPM',
  CAR_COST: 'CAR_COST',
};

export const INVOICE_TYPES = {
  INVOICE: 'invoice',
  CREDIT: 'credit',
};

export const INVOICE_SUBJECT_TYPES = {
  VEHICLE: 'vehicle',
  COST: 'cost',
  BPM: 'BPM',
  PRODUCT: 'product',
};

export const BtwOrMarge = {
  BTW: 'BTW',
  MARGE: 'marge',
};

export const IncomingCostTypes = {
  inkopen_transport: 'inkopen_transport',
  inkopen_veilingkosten: 'inkopen_veilingkosten',
  inkopen_reconditionering: 'inkopen_reconditionering',
  inkopen_stalling: 'inkopen_stalling',
  inkopen_reparaties: 'inkopen_reparaties',
  // CUSTOM_INPUT: 'CUSTOM_INPUT',
};

function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

export const OutgoingCostTypes = removeEmpty({
  omzet_transport: env.hide_transport_card ? null : 'omzet_transport',
  omzet_veilingkosten: 'omzet_veilingkosten',
  omzet_reconditionering: 'omzet_reconditionering',
  omzet_stalling: 'omzet_stalling',
  omzet_reparaties: 'omzet_reparaties',
  omzet_handling: 'omzet_handling',
});

export const FINALIZATION_STATUSES = {
  READY_TO_INITIATE: 'READY_TO_INITIATE',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  ERROR: 'ERROR',
};

export const DEFAULT_VAT_CODE = '00';
